import React from "react";

import {
    Form, Input,
} from 'antd';

import { RegistComponent, FieldBase } from "easyui-core";
import { WfComponentProps } from "../../WfComponent/WfComponentProps";


import { RegistorClass } from "../../../core/ComponentRegistor";
const { TextArea } = Input

export class AntTextarea extends React.Component<WfComponentProps> {
    field: FieldBase<any>
    constructor(props) {
        super(props)
        this.field = this.props.field
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null

        return (
            <Form.Item {...formItemLayout} label={this.props.field.label}>
                {getFieldDecorator(this.field.key, {
                    rules: [{
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.field.required, message: '必填项!',
                    }],
                })(
                    <TextArea rows={4} />
                )}
            </Form.Item>
        )
    }
}
RegistComponent({
    selector: "ef-ant-textarea",
    component: AntTextarea,
    name: "Ant文本域"
})
// export default AntTextarea